import React from 'react';
import styles from './MessageComponent.module.scss';

type Props = {
  children: React.ReactNode;
};

const MessagesContainer: React.FC<Props> = ({ children }) => {
  return <div className={`w-100 ${styles.messagesContainer}`}>{children}</div>;
};

export default MessagesContainer;
